import React from "react";
import Project from "./projetEtp";

export function ProjectFinished() {
  return <Project status="Terminé" />;
}